/**
 * Yandex SmartCaptcha в форме регистрации и восстановления: сервер требует токен со второй
 * попытки с одного адреса (спецификация 7.1). Ключ задаётся сборкой (VITE_SMARTCAPTCHA_KEY);
 * без него виджет не показывается и ничего не ломается — сервер просто не включает проверку.
 */

const SITE_KEY = import.meta.env.VITE_SMARTCAPTCHA_KEY as string | undefined
const SCRIPT = 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload'

interface SmartCaptcha {
  render: (container: HTMLElement, params: { sitekey: string; invisible?: boolean; hl?: string; callback?: (token: string) => void; 'error-callback'?: () => void }) => number
  execute: (id?: number) => void
  reset: (id?: number) => void
  destroy: (id?: number) => void
}

declare global {
  interface Window {
    smartCaptcha?: SmartCaptcha
  }
}

/** Настроена ли капча в этой сборке. */
export const captchaEnabled = Boolean(SITE_KEY)

let loading: Promise<SmartCaptcha> | null = null

function load(): Promise<SmartCaptcha> {
  if (window.smartCaptcha) return Promise.resolve(window.smartCaptcha)
  loading ??= new Promise<SmartCaptcha>((resolve, reject) => {
    const el = document.createElement('script')
    el.src = SCRIPT
    el.async = true
    el.onload = () => {
      const wait = (left: number) => {
        if (window.smartCaptcha) resolve(window.smartCaptcha)
        else if (left <= 0) reject(new Error('SmartCaptcha не поднялась'))
        else setTimeout(() => wait(left - 1), 100)
      }
      wait(30)
    }
    el.onerror = () => reject(new Error('SmartCaptcha не загрузилась'))
    document.head.appendChild(el)
  })
  return loading
}

/**
 * Показывает капчу в контейнере и отдаёт токен. Виджет невидимый: пользователь видит проверку,
 * только если SmartCaptcha сочтёт запрос подозрительным.
 */
export async function solveCaptcha(container: HTMLElement): Promise<string> {
  if (!SITE_KEY) throw new Error('Капча не настроена')
  const api = await load()
  return new Promise<string>((resolve, reject) => {
    const id: number = api.render(container, {
      sitekey: SITE_KEY,
      invisible: true,
      hl: 'ru',
      callback: (token) => {
        resolve(token)
        api.destroy(id)
      },
      'error-callback': () => {
        reject(new Error('Проверка не пройдена'))
        api.destroy(id)
      },
    })
    api.execute(id)
  })
}
